import {
    Component,
    ChangeDetectionStrategy,
    ElementRef,
    ViewEncapsulation,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DialogFullScreenComponentContent } from "../../../models/dialogs/dialog-full-screen";

@Component({
    selector: "forgot-password-email-successfully-sent",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./forgot-password-email-successfully-sent.component.html",
    styleUrls: ["./forgot-password-email-successfully-sent.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
})
export class ForgotPasswordEmailSuccessfullySent extends DialogFullScreenComponentContent {
    public logoPath = "/assets/images/toro-total-white.svg";

    constructor(
        element: ElementRef,
        private dialogReference: MatDialogRef<ForgotPasswordEmailSuccessfullySent>
    ) {
        super(element);
    }

    public dispose() {
        super.close(this.dialogReference, null);
    }
}
